import { PackageProviderName } from 'data/ppoints/constants';
import { array, nativeEnum, number, object, record, ZodIssueCode } from 'zod';

const hasDuplicateRate = (ratesByProvider: Record<string, number[]>) => {
    const seen = new Set<number>();

    return Object.values(ratesByProvider ?? {}).some((rateIds) =>
        (rateIds ?? []).some((rateId) => {
            if (seen.has(rateId)) return true;

            seen.add(rateId);
            return false;
        })
    );
};

const shippingZoneRateStepSchema = object({
    zones: record(record(nativeEnum(PackageProviderName), array(number()))).superRefine((zones, ctx) => {
        const zoneEntries = Object.entries(zones ?? {});

        const hasMappedZone = zoneEntries.some(([, providers]) =>
            Object.values(providers ?? {}).some((rateIds) => rateIds?.length)
        );

        if (!hasMappedZone) {
            ctx.addIssue({
                code: ZodIssueCode.custom,
                message: 'WIZARD.SHIPPING_ZONE_RATE_STEP.RATES_REQUIRED',
            });
        }

        zoneEntries.forEach(([zoneKey, providers]) => {
            if (!hasDuplicateRate(providers)) return;

            ctx.addIssue({
                code: ZodIssueCode.custom,
                path: [zoneKey],
                message: 'WIZARD.SHIPPING_ZONE_RATE_STEP.RATES_DUPLICATE',
            });
        });
    }),
});

export default shippingZoneRateStepSchema;
